<script setup lang="ts">
import type { ProductVariant } from "#shared/types/product-catalogue";

defineProps<{ variant: ProductVariant<string> | undefined | null }>();

const checkIconUrl = `url(${usePublicAssetUrl("/icons/GreenCheck.svg")})`;
</script>

<template>
  <div
    v-if="variant?.description"
    class="flex flex-col gap-s md:gap-m"
    v-html="variant.description"
  />
</template>

<style scoped>
@reference "~/assets/styles/main.css";

:deep(p) {
  @apply text-base md:text-xl;
}

:deep(ul, ol) {
  @apply flex flex-col gap-xs md:gap-s;

  li {
    @apply min-h-6 text-base md:text-lg list-inside leading-6! pl-[calc(var(--spacing-xs)+theme(spacing.6))];

    /* FIXME: Preferrably we should use list-style-image here, but haven't been able to center it vertically */
    background: v-bind(checkIconUrl) no-repeat;
  }
}
</style>
